var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CenterOnParent",
    { staticClass: "vh-100 bg-light m-0" },
    [
      !_vm.result
        ? _c("Spinner")
        : _c(
            "div",
            {
              staticClass: "card shadow-sm border-0 p-4 text-center",
              staticStyle: { "max-width": "500px", width: "100%" }
            },
            [
              _c("div", { staticClass: "mb-4" }, [
                !_vm.result.alreadyCompleted &&
                _vm.result.approval.approvalState === _vm.ApprovalState.Approved
                  ? _c("div", { staticClass: "display-3 text-success" }, [
                      _c("i", { staticClass: "fas fa-check-circle" })
                    ])
                  : !_vm.result.alreadyCompleted &&
                    _vm.result.approval.approvalState ===
                      _vm.ApprovalState.Rejected
                  ? _c("div", { staticClass: "display-3 text-danger" }, [
                      _c("i", { staticClass: "fas fa-times-circle" })
                    ])
                  : _c("div", { staticClass: "display-3 text-muted" }, [
                      _c("i", { staticClass: "fas fa-info-circle" })
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body p-2" }, [
                _c(
                  "h3",
                  { staticClass: "h4 mb-3 font-weight-bold text-dark" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "visitorManagement.advanceRegistration.approvalComplete.title"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-secondary lead font-weight-normal" },
                  [
                    _vm.result.alreadyCompleted
                      ? [
                          _vm.result.approval.approvalState ===
                          _vm.ApprovalState.Approved
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "visitorManagement.advanceRegistration.approvalComplete.requestAlreadyApproved"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm.result.approval.approvalState ===
                              _vm.ApprovalState.Rejected
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "visitorManagement.advanceRegistration.approvalComplete.requestAlreadyRejected"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ]
                      : [
                          _vm.result.approval.approvalState ===
                          _vm.ApprovalState.Approved
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "visitorManagement.advanceRegistration.approvalComplete.requestApproved"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm.result.approval.approvalState ===
                              _vm.ApprovalState.Rejected
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "visitorManagement.advanceRegistration.approvalComplete.requestRejected"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-footer bg-transparent border-0 mt-3" },
                [
                  _c("small", { staticClass: "text-muted d-block mb-3" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "visitorManagement.advanceRegistration.approvalComplete.actionBy"
                          )
                        ) +
                        "\n        "
                    ),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.result.approvedByContact.firstName) +
                          " " +
                          _vm._s(_vm.result.approvedByContact.lastName)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted small mb-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "visitorManagement.advanceRegistration.approvalComplete.closeWindowHint"
                          )
                        ) +
                        "\n      "
                    )
                  ])
                ]
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }